import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { i18nSymbol } from '@/i18n';
import { CELL_CONFIG_MAP } from './constants';
import _ from 'lodash';
import { FIELD_I18N_KEY, FIELD_TYPE } from './enums';
import { CUSTOM_FIELD_COLUMN_MAP } from './constants/custom-field';
let TableColumnServiceImpl = class TableColumnServiceImpl {
    constructor(_i18n) {
        this._i18n = _i18n;
    }
    getColumn(dataType, fieldData) {
        let column = null;
        // 标准字段
        if ('is_standard' in fieldData && fieldData.is_standard) {
            column = this._getStandardColumn(dataType, fieldData);
        }
        // 自定义字段
        if ('is_custom' in fieldData && fieldData.is_custom) {
            column = this._getCustomColumn(fieldData);
        }
        return column;
    }
    _getStandardColumn(dataType, fieldData) {
        const cellItem = _.get(CELL_CONFIG_MAP, `${dataType}.${fieldData.field_id}`, {});
        return {
            ...cellItem,
            data: fieldData.field_id,
            field: fieldData.field_id,
            label: this._i18n.t(`${FIELD_I18N_KEY[dataType]}.BASIC.${fieldData.field_id}`),
            fieldType: FIELD_TYPE.STANDARD,
            readOnly: true,
        };
    }
    _getCustomColumn(fieldData) {
        const cellItem = _.get(CUSTOM_FIELD_COLUMN_MAP, fieldData.field_type, {});
        return {
            ...cellItem,
            data: fieldData.field_id,
            field: fieldData.field_id,
            label: fieldData.field_name,
            fieldType: FIELD_TYPE.CUSTOM,
            customFieldType: fieldData.field_type,
            readOnly: false,
        };
    }
};
TableColumnServiceImpl = __decorate([
    injectable(),
    __param(0, inject(i18nSymbol)),
    __metadata("design:paramtypes", [Object])
], TableColumnServiceImpl);
export { TableColumnServiceImpl };
